import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../auth.service";
import {ActivatedRoute} from "@angular/router";
import {filter, first} from "rxjs/operators";
import {CompanyInfo} from '../../store/actions/company-info.action';

@Component({
    selector: 'db-login-forgot',
    templateUrl: './login-forgot.component.html',
    styleUrls: ['./login-forgot.component.scss'],
    standalone: false
})
export class LoginForgotComponent implements OnInit {

  public loading: boolean;
  public isMobile: boolean;
  public logo: string;
  public backgroundColor: string = '#1B6CF6';
  public companyInfo: CompanyInfo;

  public sendResetMailForm: FormGroup;
  public formSubmitted: boolean;
  public lastSentEmail: string = "";

  constructor(
    private _authService: AuthService,
    private _route: ActivatedRoute
  ) {
    this.formSubmitted = false;
    this.sendResetMailForm = new FormGroup({
      'email': new FormControl('', [Validators.required, Validators.email, Validators.pattern(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/)])
    });
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 991;
    this.companyInfo = this._route.snapshot.data['companyInfo'];
  }

  public onSendResetMailSubmit(): void {
    this.formSubmitted = true;

    if ( this.sendResetMailForm.valid && !this.loading) {
      this.loading = true;
      this.lastSentEmail = this.sendResetMailForm.value.email;
      this._authService.sendResetPasswordMail(this.sendResetMailForm.value.email)
        .pipe(
          filter(response => !!response),
          first()
        ).subscribe(() => {
          this.loading = false;
      });
    }
  }

}
